// extracted by mini-css-extract-plugin
module.exports = {"body":"Background_body__1FHr6","scanline":"Background_scanline__34ecY"};